import { Component, OnInit, ChangeDetectionStrategy, ChangeDetectorRef, OnDestroy } from "@angular/core";
import { Location } from "@angular/common";
import { CoreLanguageService } from "../../services/language.service";
import { WebVoucherService } from "../../services/web_voucher.service";
import { SnackBarService, snackBarMessageKey } from "../../services/snackBar.service";
import { CoreLogService } from "../../services/log.service";
import { OverlaySpinnerService } from "../overlayspinner/overlaySpiner.service";
import { Router, ActivatedRoute } from "@angular/router";
import { SnackBarMessageType, VoucherServiceType, WebShopMode } from "../../shared/contentTypes";
import { InternationalisationService } from "../../forked/angular-internationalisation";
import { Subscription } from "rxjs";
import { RouterHelperService } from "../../services/routerHelper.service";
import { CoreCOMService } from "../../services/com.service";
import { IOSHelperService } from "../../services/IOSHelper.service";
import { WarningdialogComponent } from "../../modalDialogs/warningDialog/warningDialog.component";
import { BottomSheetHelperService } from "../../services/bottomSheetHelper.service";
import { WebShopService } from "../../services/webShop.service";
import { CircularInjectionHelper } from "../../services/circularInjectionHelper";
import { LocalKeys, StorageHive } from "../../services/valueStorage.service";
import { WebshopOrdertypesService } from "../../services/webShopOrdertypes.service";
import { orderTypes } from "../../shared/models";

@Component({
  selector: "webvoucher",
  templateUrl: "./webvoucher.component.html",
  styleUrls: ["./webvoucher.component.scss"],
  providers: [WebVoucherService, OverlaySpinnerService],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class WebvoucherComponent implements OnInit, OnDestroy {
  // webvoucher code(is binded to the form)
  public webvoucherCode: string;
  public webvoucherFailed: boolean = false;
  public webvoucherFailedMessage: string = "";
  public returnUrl: string = "";
  public hideFooter: boolean = false;
  public webshopServiceWebvoucherActive: boolean = false;

  private langSubscriber: Subscription;

  constructor(private _location: Location
    , private _coreCOMService: CoreCOMService
    , private _router: Router
    , private _routerHelperService: RouterHelperService
    , private _snackBarService: SnackBarService
    , private _coreLogService: CoreLogService
    , private _changeDetectorRef: ChangeDetectorRef
    , private _webVoucherService: WebVoucherService
    , private _overlaySpinnerService: OverlaySpinnerService
    , private _objObsInjectHelper: CircularInjectionHelper
    , private _coreLanguageService: CoreLanguageService
    , private _activatedRoute: ActivatedRoute
    , private _webShopService: WebShopService
    , private _webshopOrdertypesService: WebshopOrdertypesService
    , private _internationalisationService: InternationalisationService
    , private _iosHelperService: IOSHelperService
    , private _bottomSheetHelperService: BottomSheetHelperService) {
  }

  private PushChanges(): void {
    try {
      this._changeDetectorRef.detectChanges();
    } catch (e) {
      this._coreLogService.error("WebvoucherComponent.PushChanges", "_changeDetectorRef.detectChanges (catch)", e);
    }
  }

  ngOnInit() {
    const me = this;
    me._webshopOrdertypesService.getOrdertypeByID(orderTypes.webvoucher).toPromise().then(webvoucherService => {
      me.webshopServiceWebvoucherActive = webvoucherService.supported;
      me.PushChanges();
    });

    me.langSubscriber = me._internationalisationService.localeChanged.subscribe(() => {
      me.PushChanges();
    });
    // if user routes to this page from bonussytem we navigato to returnUrl; if not navigate to webvoucherdetail
    const routeTargetData = me._activatedRoute.snapshot.data["routeTargetData"]
    me.returnUrl = routeTargetData ? routeTargetData.returnUrl : "/webvoucherdetail";

    //me.PushChanges();
  }

  // public navigateToShop() {
  //   const me = this;
  //   me._router.navigate(["/menuservice"]);
  // }

  public createWebVoucherCode() {
    const me = this;
    me._overlaySpinnerService.ShowLayoutSpinner();
    me._webVoucherService.CreateWebVoucherCode()
      .then(async response => {
        if (response.too_much_tries) {
          me.openWarningDialog("phWebvoucher_MuchTry_Title", "phWebvoucher_MuchTry_Description", "phWebvoucher_MuchTry_Button");
        } else if (response.success) {
          // to set user info data
          // me._webVoucherService.GetWebVoucher(response.cardnumber);
          await me._webShopService.onUserChange();
          me._snackBarService.ShowMessage(snackBarMessageKey.successfullyExecuted, SnackBarMessageType.Successful);
          await me.navigateByReturnURL();
        } else {
          me._snackBarService.ShowErrorMessageFailed(102);
          me._coreLogService.error("WebvoucherComponent.createWebVoucherCode", "_webVoucherService.CreateWebVoucher", "Failed");
        }
        me._overlaySpinnerService.HideLayoutSpinner();
      })
      .catch(e => {
        me._overlaySpinnerService.HideLayoutSpinner();
        me._snackBarService.ShowErrorMessageFailed(103);
        me._coreLogService.error("WebvoucherComponent.createWebVoucherCode", "_webVoucherService.CreateWebVoucher", e);
      });
  }

  /**
   * Navigate to the next Page based on the Previous URL
   * When coming from vouchercredit continues the Charge-Voucher-Process
   * Otherwise goto Return URL which defaults to webvoucherDetail
   */
  private async navigateByReturnURL() {
    const me = this;
    try {
      if (me.returnUrl.includes("vouchercredit")) {
        // vouchercredit means the user tried to charge a voucher, return to it
        await me._webShopService.setServiceMode(WebShopMode.Webvoucher, true, VoucherServiceType.Charge);
        const hasSingleLocation = await me._webShopService.HasSingleLocation(WebShopMode.Webvoucher);
        if (hasSingleLocation) {
          me._router.navigate(["/menugroup"]);
        } else {
          me._router.navigate(["/menulocation"]);
        }
      } else {
        me._router.navigateByUrl(me.returnUrl);
      }
    } catch (error) {
      me._coreLogService.error("WebvoucherComponent.navigateFurther", error);
      me._snackBarService.ShowErrorMessageFailed(104);
    }
  }

  private openWarningDialog(title: string, content: string, buttonLabel: string) {
    const me = this;
    me._bottomSheetHelperService.open(WarningdialogComponent, {
      data: {
        title: title
        , content: content
        , btnLabel: buttonLabel
      },
      panelClass: "mat-bottom-sheet-container--full-height"
    });
  }

  /**
   * Bind a Web voucher code to current user
   */
  public setWebvoucherCode(): void {
    const me = this;
    me._overlaySpinnerService.ShowLayoutSpinner();
    me._webVoucherService.SetWebVoucher(me.webvoucherCode)
      .then(async (response) => {
        if (response) {
          await me._webShopService.onUserChange();
          await me.resetBonuspoint();
          me._snackBarService.ShowMessage(snackBarMessageKey.successfullyExecuted, SnackBarMessageType.Successful);
          await me.navigateByReturnURL();
        } else {
          me.webvoucherFailedMessage = me._coreLanguageService.value("phWebvoucher_Error_WrongWebvoucher");
          me.webvoucherFailed = true;
          me.PushChanges();
        }
        me._overlaySpinnerService.HideLayoutSpinner();
      })
      .catch((e) => {
        if (Number.isInteger(e)) {
          me.webvoucherFailedMessage = me._coreLanguageService.value("phWebvoucher_Error_Blocked").replace("<delaytime>", e.toString());
          me.webvoucherFailed = true;
          me.PushChanges();
          me._overlaySpinnerService.HideLayoutSpinner();
        } else {
          me.webvoucherFailedMessage = me._coreLanguageService.value("phWebvoucher_Error_WrongWebvoucher").replace("<delaytime>", e.toString());
          me.PushChanges();
          me._coreLogService.error("WebvoucherComponent.SetWebVoucher", "_webVoucherService.SetWebVoucher", e);
          me._overlaySpinnerService.HideLayoutSpinner();
        }
      });
  }

  /**reset bonus point when webvoucher has been changed */
  private async resetBonuspoint(): Promise<void> {
    const me = this;
    try {
      const bonuspointsDataModel = await me._webVoucherService.GetBounspoints();
      me._objObsInjectHelper.yourAppServer.coreCOMService.environment.valueStorage.set(StorageHive.Local, LocalKeys.BonuspointsDataModel, bonuspointsDataModel);
    } catch (error) {
      me._coreLogService.error("WebvoucherComponent.resetBonuspoint", "_webVoucherService.GetBounspoints", error);
    }
  }

  public handleFocusEvent() {
    const me = this;
    if (me._coreCOMService.environment.client.isMobile) {
      me._routerHelperService.hideFooter();
    }
  }

  public handleBlurEvent() {
    const me = this;
    if (me._coreCOMService.environment.client.isMobile) {
      me._routerHelperService.showFooter();
    }
    me.setWebView();
  }

  public getQRCodePalceHolder() {
    const me = this;
    return me._coreLanguageService.value("phWebvoucher_vouchercode_PlaceHolder");
  }

  public navigateBack(): void {
    const me = this;
    me._location.back();
  }

  private setWebView() {
    const me = this;
    me._iosHelperService.setWebviewAfterBlur();
  }

  public disabledWebvoucherButtonClick() {
    const me = this;
    const webVouchetInput = document.getElementById("webvoucherCode");
    webVouchetInput.focus();
    webVouchetInput.blur();
    me.PushChanges();
  }

  ngOnDestroy(): void {
    const me = this;
    if (me.langSubscriber) {
      me.langSubscriber.unsubscribe();
    }
  }
}
